import styled from 'styled-components';
import CatLogoRaw from 'public/static/check_rgb_flat_ctick.svg';
import colors, {
  colorPrimary100Default,
  colorSecondary100Default,
} from '@toolshed/styleguide/styles/colors';
import { semibold } from '@toolshed/styleguide/styles/typography';
import { spacing5, spacing8 } from 'lib/mortar';

export const CatLogo = styled(CatLogoRaw)`
  width: ${spacing5};
`;

export const Wrapper = styled.div<
  StyledDiv & {
    condensed?: boolean;
    backgroundColor?: string;
  }
>`
  width: 100%;
  height: ${props => (props.condensed ? '32px' : '40px')};
  border-bottom: 1px solid ${colors.disabled};

  ${({ backgroundColor }) =>
    backgroundColor && `background-color: ${backgroundColor};`}

  color: ${colors.blue};
`;

const NotClickable = styled.div<StyledDiv>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${semibold()};

  line-height: ${spacing8};
`;

const Title = styled.span<{ isWarning: boolean } & StyledSpan>`
  color: ${({ isWarning }) =>
    isWarning ? colorSecondary100Default : colorPrimary100Default};
`;

const Button = styled.button<StyledButton & { underline: boolean }>`
  ${semibold()};

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  cursor: pointer;

  span {
    line-height: ${spacing8};
    text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  }
`;

interface TradeCardStatusProps {
  onClick?: () => void;
  hasIcon: boolean;
  isWarning: boolean;
  title: string;
  condensed?: boolean;
  disableTabIndexing?: boolean;
  underline?: boolean;
  backgroundColor?: string;
}

const TradeCardStatus = ({
  onClick,
  title,
  hasIcon,
  isWarning,
  condensed,
  disableTabIndexing,
  underline = true,
  backgroundColor,
}: TradeCardStatusProps) => {
  const clickAble = typeof onClick === 'function';

  if (!disableTabIndexing && clickAble) {
    return (
      <Wrapper condensed={condensed} backgroundColor={backgroundColor}>
        <Button onClick={onClick} underline={underline}>
          {!!hasIcon && <CatLogo aria-label="Checked Trade" />}
          <Title isWarning={isWarning}>{title}</Title>
        </Button>
      </Wrapper>
    );
  }

  return (
    <Wrapper condensed={condensed} backgroundColor={backgroundColor}>
      <NotClickable>
        {!!hasIcon && <CatLogo aria-label="Checked Trade" />}
        <Title isWarning={isWarning}>{title}</Title>
      </NotClickable>
    </Wrapper>
  );
};

export default TradeCardStatus;
